import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class KYCReportStatusService {
	private statusChanged: EventEmitter<any> = new EventEmitter();
	private status: number[];

	constructor() { }

	setData(data: number[]) {
		this.status = data;
		this.statusChanged.emit(this.status);
	}

	getNext(id: number) {
		const index = this.status.indexOf(+id);
		return this.status[index + 1];
	}

	getPrev(id: number) {
		const index = this.status.indexOf(+id);
		return this.status[index - 1];
	}
}
